<div class="modal-content">
  <app-loader-circles *ngIf="loading"></app-loader-circles>

  <div class="modal-header text-center">
    <div class="icon email"></div>
    <h3 class="modal-title">ALTERAR E-MAIL</h3>
    <small>Será neste e-mail onde o cliente irá receber todas as notificações do sistema. Deseja mesmo alterá-lo?</small>
  </div>
  <div class="modal-body text-center">
    <form class="forms" [formGroup]="form">
      <div class="form-group">
        <div class="inputs">
          <label for="email">Endereço de e-mail</label>
          <input
              class="form-control"
              type="email"
              placeholder="digite o endereço do e-mail aqui..."
              maxlength="60"
              appEmailValidator
              appShowErrorMessages
              [email]="true"
              required="true"
              requiredMessage="O campo Email é obrigatório"
              formControlName="email"
              name="email">
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
      <button class="btn btn-border-orange" (click)="close()">Voltar</button>
      <button class="btn btn-full-orange" (click)="save()">Salvar</button>
  </div>
</div>
